
<template>
  <div class="box">
    <div class="circle-box">
      <div class="circle-layout">
        <div class="layout-left">
          <div class="circle-inline"></div>
        </div>
        <div class="layout-right">
          <div class="circle-inline"></div>
        </div>
      </div>
    </div>
    
  </div>
  
</template>

<script>

  import { bus, getDict, axios } from '../common'
  

  export default {
    props: {
    },
    data(){
      return {
      }
    },
    watch:{
    },
    methods: {
      getDict,
    },
    mounted(){
    },
    created(){
      
    },
    beforeDestroy(){
    }
  }
</script>

<style lang="scss" scoped>
  /*外层布局*/
  .box{
    width: 100%;
    height: 100%;
  }
  .circle-box{
    width: 100%;
    height: 100%;
    animation: animation-wrap 2.5s linear infinite;
  }
  .circle-layout{
    width: 100%;
    height: 100%;
    animation: animation-circle 4s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  }
  .layout-left,.layout-right{
    display: inline-block;
    width: 50%;
    height: 100%;
    overflow: hidden;
    position: relative;
    &.layout-right{
      transform: scaleX(-1);
    }
  }
  /*内圈*/
  .circle-inline{
    position: absolute;
    top: 0;
    left: 0;
    width: 200%;
    height: 100%;
    border: 0.08rem solid #ffc952;
    border-radius: 50%;
    border-left-color: transparent;
    border-bottom-color: transparent;
    transform: rotate(40deg);
    animation: animation-circle-inline 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  }
  /*内圈动画*/
  @keyframes animation-circle-inline{
    0%{
        transform: rotate(40deg);
    }
    50%{
        transform: rotate(-100deg);
    }
    100%{
        transform: rotate(40deg);
    }
  }
  /*外层动画*/
  $rpm:720deg;
  @keyframes animation-circle{
    0%{
        transform: rotate(#{0 * $rpm});
    }
    25%{
        transform: rotate(#{0.25 * $rpm});
    }
    50%{
        transform: rotate(#{0.5 * $rpm});
    }
    75%{
        transform: rotate(#{0.75 * $rpm});
    }
    100%{
        transform: rotate(#{1 * $rpm});
    }
  }

  @keyframes animation-wrap{
    0%{
      transform: rotate(0deg);
    }
    100%{
      transform: rotate(360deg);
    }
  }
</style>
